<template>
  <div class="figma-prototype">
    <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" 
            class="iframe-container"
            width="430" 
            height="282" 
            src="https://embed.figma.com/proto/ytDRikORahbmfqouIj1tJl/Remote-Operation-Dashboard?node-id=63-115&p=f&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=63%3A115&embed-host=share" 
            allowfullscreen>
    </iframe>
  </div>
</template>

<script>

export default {
  name: 'remoteOperation',
}
</script>


<style scoped>
.iframe-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 800; /* optional, ensure it stays on top */
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>